import { Mappable} from "../../../_shared/mappable.class";
import { GraphBar } from "../../graph/GraphBar";
import { BarSegment } from "../../graph/BarSegment";
import { BreakdownType, Cue5050BaseReport } from "./Cue5050BaseReport";
import { DatePipe } from "@angular/common";

export class Cue5050FinancialReport implements Mappable<Cue5050FinancialReport>, Cue5050BaseReport {

    constructor(data: Partial<Cue5050FinancialReport>) {
        Object.assign(this, data);
        this.datePipe = new DatePipe("en-US");
    }

    datePipe: DatePipe;

    cue5050Id: number;
    name: string;
    eventStartDate: Date;
    eventEndDate: Date;
    grossTotal: number;
    cardTotal: number;
    onlineTotal: number;
    cashTotal: number;
    netTotal: number;
    cueFees: number;
    expenseFees: number;
    stripeFees: number;
    stationBreakdown: StationRevenueBreakdown[];

    getBarMappingsByBreakdownType(type: BreakdownType): GraphBar {
        switch(type){
            case BreakdownType.SalesByPaymentMethod:
                return this.getPurchaseTypeMappings();
            case BreakdownType.SalesByFeesAndNet:
                return this.getNetFeesMappings();
            case BreakdownType.SalesByStation:
                return this.getStationRevenueMappings();
            default:
                break;
        }
    }

    getBreakdownTypes(): BreakdownType[] {
        return [BreakdownType.SalesByPaymentMethod, BreakdownType.SalesByFeesAndNet, BreakdownType.SalesByStation];
    }

    getBreakdownByBreakdownType(type: BreakdownType): string[] {
        switch(type){
            case BreakdownType.SalesByPaymentMethod:
                return ["Card Purchases", "Cash Purchases", "Online Purchases"];
            case BreakdownType.SalesByFeesAndNet:
                return ["Net Revenue", "CUE Fees", "Expense Fees", "Stripe Fees"];
            case BreakdownType.SalesByStation:
                return ["Online Sales"].concat(this.stationBreakdown.map(s => s.name));
            default:
                return [];
        }
    }

    getYAxisName() {
        return 'Total Sales';
    }

    getXAxisName() {
        return 'Event Date';
    }

    getPurchaseTypeMappings(): GraphBar{
        return {
            name: this.datePipe.transform(this.eventStartDate),
            description: this.name,
            size: this.grossTotal,
            segments: [{name: 'Card Purchases', size: this.cardTotal}, 
                       {name: 'Cash Purchases', size: this.cashTotal}, 
                       {name: 'Online Purchases', size: this.onlineTotal}]
        } as GraphBar
    }

    getNetFeesMappings(): GraphBar{
        return {
            name: this.datePipe.transform(this.eventStartDate),
            description: this.name,
            size: this.grossTotal,
            segments: [{name: 'Net Revenue', size: this.netTotal}, 
                       {name: 'CUE Fees', size: this.cueFees}, 
                       {name: 'Expense Fees', size: this.expenseFees}, 
                       {name: 'Stripe Fees', size: this.stripeFees}]
        } as GraphBar
    }

    getStationRevenueMappings(): GraphBar{
        return {
            name: this.datePipe.transform(this.eventStartDate),
            description: this.name,
            size: this.grossTotal,
            segments: [{name: "Online Sales", size: this.onlineTotal}].concat(this.stationBreakdown.map(s => {
                return {
                    name: s.name,
                    size: s.total
                } as BarSegment;
            }))
        } as GraphBar;
    }
}

export class StationRevenueBreakdown {
    name: string;
    total: number;
}